import { format, parseISO } from 'date-fns';

import { GeneralConstants } from '../constants/general-constants';
import { User } from '../model/user';

const PERCENT_MULTIPLIER = 100;

export class Formatters {
    public static seamRequestId(id?: string): string {
        if (!id) {
            return '';
        }

        return `SM-${id.substring(0, GeneralConstants.SHORT_ID_LENGTH)}`;
    }

    public static crisRequestId(id?: string): string {
        if (!id) {
            return '';
        }

        return `CS-${id.substring(0, GeneralConstants.SHORT_ID_LENGTH)}`;
    }

    public static dateTime(dateString?: string, defaultIfEmpty?: string): string {
        if (!dateString) {
            return defaultIfEmpty || '';
        }

        return format(parseISO(dateString), 'MM/dd/yyyy h:mm:ss a');
    }

    public static date(dateString?: string, defaultIfEmpty?: string): string {
        if (!dateString) {
            return defaultIfEmpty || '';
        }

        return format(parseISO(dateString), 'MM/dd/yyyy');
    }

    public static monthYearFormatter(dateString?: string): string {
        if (!dateString) {
            return '';
        }

        return format(parseISO(dateString), 'MMM yyyy');
    }

    public static userDisplayName(user?: User): string {
        if (!user) {
            return '';
        }

        return `${user.first} ${user.last} (${user.username})`;
    }

    public static percent(value: number, maximumFractionDigits: number): string {
        return (value * PERCENT_MULTIPLIER).toLocaleString(undefined, { maximumFractionDigits });
    }
}
